module.exports = __webpack_public_path__ + "static/media/lulian.3d002375.jpg";